import { Typography, Container, Grid, Stack } from '@mui/material';
import React from 'react';

export const LeagueRules = () => {
  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item sm={12} md={12}>
          <Typography variant="h5led" textAlign={'center'} letterSpacing={5}>
            RULES
          </Typography>
        </Grid>
        <Grid item sm={12} md={12}>
          <Stack spacing={2} sx={{ color: '#dedede' }}>
            <Typography variant="h6" fontWeight={600}>
              STRUCTURE
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Size of divisions TBD based on level of interest. Games within
              division will be round robin.
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Playoff format TBD based on number of teams/divisions.
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Each week’s match will be 3 games of 20 Qs (1 per category).
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Matches can end in draws, if games result in 1-1-1 or 0-0-3
              (W-L-D) and the standings will accommodate draws.
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Profiles will include section recording historical league stats.
              Weekly badges to be handed out in profiles. Extremely prestigious
              Championship and Season Award badges will also be highly visible
              in profiles and league landing pages. Awards TBD but ones such as
              MVP will be obvious.
            </Typography>
            <Typography variant="h6" fontWeight={600}>
              GAMEPLAY
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Questions will be 30 seconds long instead of 20 seconds. Clues
              will have more fluidity, and the prompt for what’s being asked
              might not be obviously until further progression (less “This
              President…”, more Quiz Bowl style).
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Questions will internally have 1-5 difficulty scaling which will
              cycle for each category per set (e.g. History may be difficulty 1
              in one set, 3 in the next, etc until it cycles back to 1; Video
              Games may be difficulty 5 in that first set and its difficulty
              would move in parallel to History).
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Exact spelling only. No fuzzy!
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - Communication among teammates during matches is not only allowed
              but encouraged. A team that’s not communicating during a match
              will actually likely be at a severe disadvantage.
            </Typography>
            <Typography fontFamily={'helvetica'}>
              - In case of mistakes within a question, if 1) mistake materially
              changed outcome of game, 2) teams can agree to how the outcome
              would have played out – message mods and we will adjust results
              accordingly.
            </Typography>
            <Typography fontFamily={'helvetica'}>
              {'  '}If 1) but not 2), mods can be called in to adjudicate
              result.
            </Typography>
            <Typography fontFamily={'helvetica'}>
              {'  '}If not 1), please still contact mod for question correction
              and player stat adjustments.
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};
